import React from "react";

const AboutFozzil = () => (
  <div className="bg-black text-white font-secondary min-h-screen w-full p-0 m-0">
    <section
      className="relative w-screen min-h-[260px] flex items-center justify-center overflow-hidden"
      style={{
        background: "url('/AboutHero.png') center/cover no-repeat, #000",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/90 z-0" />
      <h1 className="relative z-10 font-primary text-[1.3rem] md:text-[2rem] lg:text-[2.3rem] text-white text-center tracking-wider m-0 py-10 px-4 drop-shadow-lg whitespace-nowrap overflow-x-auto">
        <span className="text-[#0099f2]">
          Future Oriented Zone-of Intelligent Life
        </span>
      </h1>
    </section>

    <section className="bg-black pb-16 pt-6">
      <div className="max-w-[1200px] mx-auto flex flex-row items-start justify-between gap-12 px-10 md:flex-col md:gap-8 md:px-4 sm:px-2">
        <div className="flex-1 bg-white/5 backdrop-blur-md rounded-2xl shadow-2xl p-10 md:p-6 border border-[#232b6c]/40 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#0099f2] via-transparent to-[#232b6c]/60 rounded-t-2xl animate-pulse" />
          <h2 className="font-primary text-3xl md:text-4xl text-[#0099f2] mt-2 mb-4 text-left tracking-wider capitalize sm:text-2xl">
            Our Services
          </h2>
          <h3 className="font-primary text-2xl md:text-2xl text-white mb-4 font-bold text-left sm:text-lg">
            Intelligent Evolution, Engineered for You
          </h3>
          <p className="font-secondary text-lg md:text-xl text-gray-300 my-6 text-justify leading-relaxed w-full">
            At FOZZIL, we build adaptive intelligence that evolves with your
            business and, powered by ethical AGI, turns complexity into
            clarity—one smart step at a time.
          </p>
          <div className="flex justify-center px-0 my-8 w-full">
            <iframe
              title="vimeo-player"
              src="https://player.vimeo.com/video/862930606?h=e37d5ebcee"
              className="w-full max-w-[700px] aspect-video rounded-xl border-2 border-[#0099f2]/30 shadow-lg"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-gradient-to-b from-black via-[#101a3a]/80 to-black pb-16 pt-6">
      <div className="max-w-[1200px] mx-auto px-10 md:px-4">
        <h2 className="font-primary text-3xl md:text-4xl text-[#0099f2] mt-6 md:mt-10 mb-2 text-left tracking-wider capitalize sm:text-2xl">
          What is FOZZIL?
        </h2>
        <div className="h-1 w-24 bg-gradient-to-r from-[#0099f2] to-[#232b6c] rounded-full mb-10 mt-2 animate-pulse" />
      </div>
      <div className="flex flex-row max-w-[1200px] mx-auto px-10 gap-12 md:flex-col md:gap-8 md:px-4 sm:px-2 sm:gap-3">
        <div className="flex-2 bg-white/5 backdrop-blur-md rounded-2xl shadow-xl p-10 md:p-6 border border-[#232b6c]/40">
          <p className="text-lg md:text-xl text-gray-300 mb-5 font-secondary text-justify">
            <span className="text-[#0099f2] font-bold">FOZZIL</span> is an AI
            Research & Development Company pioneering adaptive, ethical, and
            human-centered Artificial General Intelligence. We advance AGI as a
            transformative partner in human progress—across healthcare,
            education, enterprise, and daily life—by creating intelligent
            systems that learn from real-world interactions and deliver
            scalable, context-aware solutions.
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-5 font-secondary text-justify">
            <span className="font-bold text-white">Ethical considerations</span>{" "}
            at FOZZIL are embedded in every layer. We uphold transparency,
            fairness, and accountability, ensuring compliance and safeguarding
            data. Our systems augment human capabilities, fostering
            collaboration and well-being.
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-5 font-secondary text-justify">
            Our team of AI researchers, data scientists, and domain experts
            drives responsible innovation and measurable impact through
            trustworthy, intelligent tools.
          </p>
        </div>
        <div className="flex-1 flex flex-col items-start justify-start mt-6 bg-white/5 backdrop-blur-md rounded-2xl shadow-xl p-8 border border-[#232b6c]/40">
          <h3 className="font-primary text-xl md:text-2xl text-[#0099f2] mb-4 font-semibold text-left">
            Learn More
          </h3>
          <p className="text-lg md:text-xl text-gray-300 mb-8 font-secondary text-justify">
            Our Adaptive Intelligence is a unified, evolving cognitive layer
            that automates, learns, and connects across every device and
            system—seamlessly coordinating workflows and growing smarter with
            every interaction.
          </p>
        </div>
      </div>
    </section>

    <section className="bg-black pb-16 pt-6">
      <div className="max-w-[1200px] mx-auto flex flex-col-reverse md:flex-row items-center gap-12 px-10 md:px-4 sm:px-2">
        <div className="flex-1 flex flex-col items-start justify-center w-full">
          <h2 className="font-primary text-3xl md:text-4xl text-[#0099f2] mt-6 md:mt-10 mb-2 text-left tracking-wider capitalize sm:text-2xl">
            Our Mission
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#0099f2] to-[#232b6c] rounded-full mb-8 mt-2 animate-pulse" />
          <p className="text-lg md:text-xl text-gray-300 text-justify font-secondary leading-relaxed mb-4">
            Building the world’s first true Artificial General Intelligence that
            learns from humanity, grows with it, and empowers every system,
            organization, and individual to think smarter, act faster, and live
            the best — in real time, across every domain. <br />{" "}
            <span className="block mt-4">
              Featured with Adaptive Intelligence and Self-Learning Systems.
              This isn’t just about smarter algorithms—it's about a single,
              evolving intelligence that learns, transfers knowledge, and grows
              in real time like a mind that never stops developing.
            </span>
          </p>
        </div>
        <div className="flex-1 flex items-center justify-center w-full mb-8 md:mb-0">
          <div
            className="rounded-2xl min-w-[180px] min-h-[180px] w-full max-w-[320px] aspect-square shadow-xl border border-[#232b6c]/40 bg-white/5 backdrop-blur-md"
            style={{ background: "url('/logoicon.png') center/60% no-repeat" }}
          ></div>
        </div>
      </div>
    </section>

    <section className="bg-gradient-to-b from-black via-[#101a3a]/80 to-black pb-20 pt-6">
      <div className="max-w-[1200px] mx-auto px-10 md:px-4">
        <h2 className="font-primary text-3xl md:text-4xl text-[#0099f2] mt-6 md:mt-10 mb-2 text-left tracking-wider capitalize sm:text-2xl">
          Our Vision
        </h2>
        <div className="h-1 w-24 bg-gradient-to-r from-[#0099f2] to-[#232b6c] rounded-full mb-10 mt-2 animate-pulse" />
      </div>
      <div
        className="w-full max-w-[1200px] aspect-video rounded-2xl mx-auto mb-10 px-10 md:px-4 shadow-xl border border-[#232b6c]/40 bg-white/5 backdrop-blur-md"
        style={{ background: "url('/solution.png') center/cover no-repeat" }}
      ></div>
      <div className="max-w-[1200px] mx-auto text-left px-10 flex flex-col items-start md:px-4 sm:px-2">
        <p className="text-xl md:text-2xl text-white font-bold mb-6 font-secondary text-justify">
          FOZZIL envisions a future to train Human Intelligence to work smarter
          through Artificial General Intelligence.
        </p>
        <p className="text-lg md:text-xl text-gray-300 mb-5 font-secondary text-justify">
          We develop AGI systems that elevate human potential, enhance
          productivity, and foster seamless collaboration between humans and
          machines. AGI as an ally in human progress, expanding knowledge and
          enabling smarter decisions.
        </p>
        <p className="text-lg md:text-xl text-gray-300 mb-5 font-secondary text-justify">
          We see AGI innovations reshaping industries and empowering businesses
          and lives. Our mission: redefine what's possible in a smarter, more
          connected world.
        </p>
        <div
          className="w-[320px] h-[80px] mx-auto mt-10 md:w-[180px] md:h-[50px] sm:w-[100px] sm:h-[30px] sm:mt-5"
          style={{ background: "url('/logo.png') center/contain no-repeat" }}
        ></div>
      </div>
    </section>
  </div>
);

export default AboutFozzil;
